const routes = [
  {
    path: 'report-export',
    name: 'reportExport',
    component: () => import(/* webpackChunkName: "calibration-app" */ './views/Index.vue'),
    meta: {
      // permissionRequired: true,
    },
  },
];

export default routes;
